var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10509_51743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern0_10509_51743)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern1_10509_51743)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10509_51743)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern2_10509_51743)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern3_10509_51743)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#01924F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10509_51743",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10509_51743",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_10509_51743",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10509_51743",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_10509_51743",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10509_51743",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_10509_51743",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10509_51743",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10509_51743",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.079b41c45170b7df612079de73cda21d.svg";
export { ForwardRef as ReactComponent };